// Aufgeklappte Abschnitte merken (Website-Audit: Kategorien, src/Storage/UserSettings.php):
// Jedes Auf- und Zuklappen speichert im Konto, welche offen stehen - beim nächsten Besuch,
// auch auf einem anderen Gerät, stehen dieselben offen. Ein Link auf einen zugeklappten
// Abschnitt (die Kacheln der Kategorien) klappt ihn auf. Ohne JavaScript klappen die
// Abschnitte wie immer, gemerkt wird nichts.
export default function rememberOpen() {
  document.querySelectorAll('[data-remember-open]').forEach(function (root) {
    const items = Array.from(root.querySelectorAll('details[data-remember]'));
    if (!items.length) return;
    const openKeys = function () {
      return items.filter((item) => item.open).map((item) => item.dataset.remember);
    };
    // Gespeicherter Stand - so geht beim Laden der Seite nichts an den Server.
    let saved = openKeys().join(' ');
    let timer = null;

    function save() {
      clearTimeout(timer);
      // Mehrere Klicks kurz hintereinander: ein Request mit dem letzten Stand.
      timer = setTimeout(function () {
        const keys = openKeys();
        if (keys.join(' ') === saved) return;
        const body = new URLSearchParams({ _token: root.dataset.token, name: root.dataset.rememberOpen });
        keys.forEach((key) => body.append('open[]', key));
        fetch(root.dataset.url, { method: 'POST', headers: { Accept: 'application/json' }, body: body })
          .then(function (res) {
            if (res.ok) saved = keys.join(' ');
          })
          // Nicht gespeichert (Sitzung abgelaufen, keine Verbindung): beim nächsten Klappen erneut.
          .catch(function () {});
      }, 400);
    }
    items.forEach((item) => item.addEventListener('toggle', save));

    // Sprung auf einen zugeklappten Abschnitt (#kategorie-…): aufklappen.
    function reveal(id) {
      const target = items.find((item) => item.id === id);
      if (target && !target.open) target.open = true;
    }
    document.addEventListener('click', function (event) {
      const link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
      if (link) reveal(decodeURIComponent(link.getAttribute('href').slice(1)));
    });
    if (window.location.hash) reveal(decodeURIComponent(window.location.hash.slice(1)));
  });
}
